import { graphql } from '../graphql';

/**
 * Layer-context entry point: takes an existing POINTCLOUD layer + the SMRF /
 * CSF parameter blob and returns the synthetic batch ID created by the
 * server. Mirrors `startDeviationAnalysis` in deviation.query.ts.
 */
export const startGroundClassification = graphql(`
  mutation StartGroundClassification($input: StartGroundClassificationInput!) {
    startGroundClassification(input: $input)
  }
`);
